import { productService, Product } from "../api/productService";

// React Query
import { useQuery } from "@tanstack/react-query";

export const useProducts = () => {
  return useQuery({
    queryKey: ["products"],
    queryFn: productService.getAllProducts,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};

export const useFeaturedProducts = () => {
  return useQuery({
    queryKey: ["products", "featured"],
    queryFn: async () => {
      const products = await productService.getAllProducts();
      return products.filter((product: Product) => product.isFeaturedProduct);
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};
